export function ELKToPositions(node) {
    const result = {};
    traverseELKNodes(node, (id, position, size) => {
        result[id] = { x: position.x + size.width / 2, y: position.y + size.height / 2 };
    });
    return result;
}
/**
 * Traverses all nodes, besides the root, and calls the callback with its absolute position, size, and ID.
 */
function traverseELKNodes(rootNode, callback) {
    const toProcess = ((rootNode === null || rootNode === void 0 ? void 0 : rootNode.children) || []).map((n) => [n, { x: 0, y: 0 }]);
    while (toProcess.length) {
        const [node, origin] = toProcess.pop();
        const position = { x: node.x + origin.x, y: node.y + origin.y };
        callback(node.id, position, { width: node.width, height: node.height });
        node.children.forEach((n) => toProcess.push([n, position]));
    }
}
